module.exports = __webpack_public_path__ + "img/loader-black.d4f772c1.gif";